export default ({preview, tree}) => {
    let previewScript = "";
  if (preview) {
    previewScript = `
      <script>
        $(document).ready(function() {
          document.querySelectorAll("a").forEach(function(ele) {
            var linkType = ele.dataset["linkType"];
            if (linkType === "anchor") {
              var arr = ele.href.split("#");
              var contentID = arr[arr.length-1];
              ele.href="javascript:void(0);";
              ele.onclick = function() {
                document.getElementById(contentID).scrollIntoView();
              };
            }
          });
        });
      </script>
    `;
  }

  let googleAnalyticsScript = "";
  if (tree.root.data.googleAnalyticsID) {
    googleAnalyticsScript = `
      <!-- Google tag (gtag.js) -->
      <script async src="https://www.googletagmanager.com/gtag/js?id=${
        tree.root.data.googleAnalyticsID || ""
      }"></script>
      <script>
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${tree.root.data.googleAnalyticsID || ""}');
      </script>
    `;
  }

  let metaKeywords = "";
  if (tree.root.data.metaKeywords) {
    metaKeywords = `<meta name="keywords" content="${tree.root.data.metaKeywords}">`;
  }
  let metaDescription = "";
  if (tree.root.data.metaDescription) {
    metaDescription = `<meta name="description" content="${tree.root.data.metaDescription}">`;
  }

  let metaRobots = "";
  if (tree.root.data.metaNoFollow && tree.root.data.metaNoIndex) {
    metaRobots = `<meta name="robots" content="nofollow,noindex">`;
  } else if (tree.root.data.metaNoFollow) {
    metaRobots = `<meta name="robots" content="nofollow,index">`;
  } else if (tree.root.data.metaNoIndex) {
    metaRobots = `<meta name="robots" content="follow,noindex">`;
  } else {
    metaRobots = `<meta name="robots" content="follow,index">`;
  }

  return {
    previewScript,
    googleAnalyticsScript,
    metaKeywords,
    metaDescription,
    metaRobots,
  }
}